module.exports = __webpack_public_path__ + "assets/tinymce.bc017a29.svg";